import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import "./landing.css";

const ITEMS = [
	{
		href: "#denuncias",
		label: "Denuncia aquí",
		hint: "Envía tu denuncia con pruebas",
		Icon: CampaignOutlinedIcon,
	},
	{
		href: "#gestion",
		label: "Gestión en video",
		hint: "Debates y control político",
		Icon: PlayCircleOutlineIcon,
	},
	{
		href: "#blogs",
		label: "Sala de prensa",
		hint: "Noticias y actualidad",
		Icon: ArticleOutlinedIcon,
	},
];

const QuickLinks = () => (
	<nav className="ld-quick-wrap" aria-label="Accesos rápidos">
		<div className="ld-container">
			<div className="ld-quick">
				<p className="ld-quick-title">¿Qué estás buscando?</p>
				<div className="ld-quick-grid">
					{ITEMS.map(({ href, label, hint, Icon }) => (
						<a key={href} href={href} className="ld-quick-item">
							<span className="ld-quick-icon">
								<Icon fontSize="medium" />
							</span>
							<span className="ld-quick-label">{label}</span>
							<span className="ld-quick-hint">{hint}</span>
						</a>
					))}
				</div>
			</div>
		</div>
	</nav>
);

export default QuickLinks;
